import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import Home from "./pages/Home";
import Shop from "./pages/Shop";
import ProductDetail from "./pages/ProductDetail";
import Success from "./pages/Success";
import StoreLayout from "./components/StoreLayout";
import { lazy, Suspense } from "react";
import Devotionals from "./pages/Devotionals";
import BundleDetail from "./pages/BundleDetail";
import CollectionPage from "./pages/CollectionPage";
import LibraryPage from "./pages/LibraryPage";
import VersePage from "./pages/VersePage";
import PreferencesPage from "./pages/PreferencesPage";

// Admin console is code-split so the public storefront ships a much smaller bundle.
const AdminLogin = lazy(() => import("./pages/AdminLogin"));
const AdminLayout = lazy(() => import("./components/AdminLayout"));
const AdminOverview = lazy(() => import("./pages/admin/Overview"));
const ProductsPanel = lazy(() => import("./pages/admin/ProductsPanel"));
const StorefrontPanel = lazy(() => import("./pages/admin/StorefrontPanel"));
const AIAssistant = lazy(() => import("./pages/admin/AIAssistant"));
const SocialStudio = lazy(() => import("./pages/admin/SocialStudio"));
const SubscribersPanel = lazy(() => import("./pages/admin/SubscribersPanel"));
const OrdersPanel = lazy(() => import("./pages/admin/OrdersPanel"));
const ShippingPanel = lazy(() => import("./pages/admin/ShippingPanel"));
const EmailStudio = lazy(() => import("./pages/admin/EmailStudio"));
const BundlesPanel = lazy(() => import("./pages/admin/BundlesPanel"));
const CollectionsPanel = lazy(() => import("./pages/admin/CollectionsPanel"));
const ReviewsPanel = lazy(() => import("./pages/admin/ReviewsPanel"));
const PromosPanel = lazy(() => import("./pages/admin/PromosPanel"));
const Fallback = () => <div className="min-h-screen flex items-center justify-center text-[#4a4a4a]">Loading…</div>;

function RequireAdmin({ children }) {
  const t = typeof window !== "undefined" && localStorage.getItem("fs_token");
  if (!t) return <Navigate to="/admin/login" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <Toaster position="top-right" richColors />
      <BrowserRouter>
        <Suspense fallback={<Fallback />}>
        <Routes>
          <Route element={<StoreLayout />}>
            <Route path="/" element={<Home />} />
            <Route path="/shop" element={<Shop />} />
            <Route path="/product/:id" element={<ProductDetail />} />
            <Route path="/bundle/:id" element={<BundleDetail />} />
            <Route path="/devotionals" element={<Devotionals />} />
            <Route path="/verse" element={<VersePage />} />
            <Route path="/preferences" element={<PreferencesPage />} />
            <Route path="/collections/:slug" element={<CollectionPage />} />
            <Route path="/library" element={<LibraryPage />} />
            <Route path="/success" element={<Success />} />
          </Route>

          <Route path="/admin/login" element={<AdminLogin />} />
          <Route
            path="/admin"
            element={
              <RequireAdmin>
                <AdminLayout />
              </RequireAdmin>
            }
          >
            <Route index element={<AdminOverview />} />
            <Route path="products" element={<ProductsPanel />} />
            <Route path="bundles" element={<BundlesPanel />} />
            <Route path="collections" element={<CollectionsPanel />} />
            <Route path="reviews" element={<ReviewsPanel />} />
            <Route path="promos" element={<PromosPanel />} />
            <Route path="storefront" element={<StorefrontPanel />} />
            <Route path="assistant" element={<AIAssistant />} />
            <Route path="social" element={<SocialStudio />} />
            <Route path="email" element={<EmailStudio />} />
            <Route path="subscribers" element={<SubscribersPanel />} />
            <Route path="orders" element={<OrdersPanel />} />
            <Route path="shipping" element={<ShippingPanel />} />
          </Route>
        </Routes>
        </Suspense>
      </BrowserRouter>
    </div>
  );
}

export default App;
